import { useEffect, useState } from "react";
import { getOrders, startOrder } from "../common/api/orders";
import { getUserByUsername } from "../common/api/users";
import { getGroupByName } from "../common/api/groups";
import { getCurrentUsername } from "../common/api/auth";
import Layout from "../components/Layout";

function CreateWorkOrder() {
  const [orders, setOrders] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [groupIds, setGroupIds] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const username = getCurrentUsername();
        const orders = await getOrders(username, 1, 2);
        setOrders(orders);
      } catch (err) {
        console.error("Error al cargar órdenes:", err);
        alert("No se pudieron cargar las órdenes");
      }
    };

    const fetchUserData = async () => {
      const username = getCurrentUsername();
      const user = await getUserByUsername(username);
      setCurrentUser(user);

      if (user?.GRUPOS?.length) {
        const groups = await Promise.all(user.GRUPOS.map((g) => getGroupByName(g)));
        const ids = groups.map((g) => g.COD_ID).filter(Boolean);
        setGroupIds(ids);

        console.log("Grupos del usuario:");
        groups.forEach((g) =>
          console.log(`- ${g.NOMBRE} => COD_ID: ${g.COD_ID}`)
        );
      }
    };

    fetchOrders();
    fetchUserData();
  }, []);

  const handleToggle = (item) => {
    const exists = selectedOrders.find((o) => o.COD_ID === item.COD_ID);
    if (exists) {
      setSelectedOrders((prev) => prev.filter((o) => o.COD_ID !== item.COD_ID));
    } else {
      setSelectedOrders((prev) => [...prev, item]);
    }
  };

  const canStartOrder = (order) => {
    if (order.Estado !== "1") return false;
    if (!currentUser) return false;
    const isForUser = order.COD_ID_USER === currentUser.COD_ID;
    const isForGroup = groupIds.includes(order.COD_ID_USER_GROUP);
    return isForUser || isForGroup;
  };

  const hasBiConnectRole = currentUser?.ROLES?.some(
    (r) => r.App === "BiConnectPro" && r.Rol === "BICONNECTPRO"
  );

  const handleCreateParte = async () => {
    if (selectedOrders.length === 0) {
      alert("Selecciona al menos un parte");
      return;
    }

    const validParts = selectedOrders.filter(canStartOrder);
    const skipped = selectedOrders.length - validParts.length;

    try {
      let okCount = 0;
      for (const part of validParts) {
        const response = await startOrder(part.COD_ID);
        if (response?.status === "OK") {
          okCount++;
        } else {
          console.warn(`❌ Error al iniciar parte ${part.COD_ID}`);
        }
      }

      let msg = `${okCount} parte(s) iniciados correctamente.`;
      if (skipped > 0) msg += ` ${skipped} parte(s) no autorizados.`;
      alert(msg);
      setSelectedOrders([]);
    } catch (err) {
      console.error("❌ Error general al iniciar partes:", err);
      alert("Error al iniciar uno o más partes. Consulta consola.");
    }
  };

  return (
    <Layout>
      <div className="dashboard">
        <div className="ventana mostrar">
          <span className="ventana_tittle">Asignar Parte de Trabajo</span>

          <div className="ventana_resultado_visible">
            {!hasBiConnectRole && (
              <div className="alert-warning">
                ⚠️ No puedes iniciar partes porque tu usuario no tiene el rol requerido (BICONNECTPRO).
              </div>
            )}

            <div className="tabla">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>CUPS</th>
                    <th>CntID</th>
                    <th>Nombre CT</th>
                    <th>Dirección suministro</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((item) => (
                    <tr key={item.COD_ID}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedOrders.some((o) => o.COD_ID === item.COD_ID)}
                          onChange={() => handleToggle(item)}
                        />
                      </td>
                      <td>{item.CUPS}</td>
                      <td>{item.CntId}</td>
                      <td>{item.NOMBRECT}</td>
                      <td>{item.DIRECCIONSUMINISTRO}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="input-group_2">
                <span className="boton_opciones" onClick={handleCreateParte}>
                  Asignar parte(s) seleccionados ({selectedOrders.length})
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default CreateWorkOrder;
